import axios from 'axios';

import { ChangePasswordSchemaType } from '@/components/organisms/ChangePasswordForm/schema';
import { ProfileSchemaType } from '@/components/organisms/ProfileForm/schema';

export type UserResponse = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
};

export type UpdatePasswordResponse = {
  message: string;
};

export const updateUser = async (updateUserData: ProfileSchemaType): Promise<UserResponse> => {
  const response = await axios.put(`https://run.mocky.io/v3/8236cefb-a712-403b-9a7a-b8147ba02ce5`, updateUserData);
  return response.data;
};

export const updateUserPassword = async (updatePasswordData: ChangePasswordSchemaType): Promise<UpdatePasswordResponse> => {
  const response = await axios.put(`https://run.mocky.io/v3/ac5f8435-146a-4dc7-8a52-68a77419fd4f`, updatePasswordData);
  return response.data;
};
